import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component } from '@angular/core';
import { inject } from '@angular/core/testing';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BasicGroupByOptions } from 'rxjs';
import { JwtToken, login } from 'src/app/Models/login';
import { UserItem } from 'src/app/Models/Users';

import { AuthenticationService } from 'src/app/Services/authentication.service';
import { UserStateService } from 'src/app/Services/commonservice.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  loading:boolean=false
forgotPasswordCart:boolean=false
setForgotNewPasswordCart:boolean=false
 forgotPasswordEmailForm!: FormGroup
 forgotPasswordIsMailThrough:boolean=true
  submittedForgotPasswordEmail: boolean = false
  otpEntered: boolean = false
    isVerifyForgotPasswordOTP: boolean = false
  otpValueEmail: string = ''
    confirmPasswordFieldType: string = 'password'
    passwordFieldType: string = 'password'
  singINPasswordFieldType: string = 'password'
  submittedForgotPasswordMobile: boolean = false
  forgotPasswordResMessage: string = ''
  isforgotPasswordStatus: boolean = false
  submittedFPMobileVerifyOTP: boolean = false
  submittedFPEmailVerifyOTP: boolean = false
   forgotPasswordMobileForm!: FormGroup
  submitedResetPassword: boolean = false
  resetPasswordMessage: { text: string; isSuccess: boolean } | null = null
  resetPasswordForm!: FormGroup
  advtiserInviteToken: string = ''
  advtiserInviteThumbnailUrl: string = ''
  rememberMe:boolean=false

ngOnInit() {
    this.resetPasswordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required]
      },
      { validators: this.passwordMatchValidator }
    );
  this.resetPasswordForm.get('password')?.valueChanges.subscribe(() => {
    this.resetPasswordForm.updateValueAndValidity();
  });
  this.resetPasswordForm.get('confirmPassword')?.valueChanges.subscribe(() => {
    this.resetPasswordForm.updateValueAndValidity();
  });

   const userData = localStorage.getItem('userData') ;
  const token = localStorage.getItem('token') ;

  if(userData && token){
      sessionStorage.setItem('userData', userData);
  sessionStorage.setItem('token', token);
      localStorage.setItem('userData', JSON.stringify(userData));
          localStorage.setItem('token', token);
    
  }
}


passwordMatchValidator(form: FormGroup) {
  const password = form.get('password')?.value;
  const confirmPassword = form.get('confirmPassword')?.value;

  if (password !== confirmPassword) {
    return { passwordMismatch: true };
  } else {
    return null;
  }
}

  otpConfig = {
    length: 4,
    allowNumbersOnly: true,
    inputStyles: {
      width: '50px',
      height: '50px',
      'font-size': '20px',
      'border-radius': '12px',
      border: '1px solid #ccc',
      'text-align': 'center',
      color: '#000',
    },
  };



  loginForm: FormGroup;
  loginrequest:login=
  {
    email:'',
    password:'',
     isSuccess:false,
     loggedUser:{},
      jwT_Token: {
      token: '',
      expiresAt: ''
    },
    errorMessage:''
  }
error:string|null = null;

   user: Partial<UserItem> = {};


  
  
  constructor( private authservice: AuthenticationService,
    
    private http:HttpClient,
    private fb:FormBuilder,
    private router:Router,
    private toaster:CustomToasterServiceService,
        private changeDetector: ChangeDetectorRef,
        private userStateService:UserStateService

  
  ){

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }


showPassword: boolean = false;

togglePasswordVisibility() {
  this.showPassword = !this.showPassword;
}
  toggleConfirmPassword() {
    this.confirmPasswordFieldType =
      this.confirmPasswordFieldType === 'password' ? 'text' : 'password'
  }

resetPassword(){
   const newPassword = this.resetPasswordForm.get('password')?.value;
   this.authservice.updateForgottedpassword(this.forgotPasswordEmail,newPassword).subscribe((res)=>{
    if(res.statusCode==200){
      this.toaster.success("Your password has been updated successfully. Please log in using your new password")
         setTimeout(() => {
          this.forgotPasswordCart=false
     
    }, 3000);
    }
    else{
      this.toaster.error("Something Went Wrong")
    }
   })

}


onRememberChange(isChecked: boolean) {

  
}
  toggleSignINPassword() {
    debugger
    this.singINPasswordFieldType = this.singINPasswordFieldType === 'password' ? 'text' : 'password'
  }

toggleForgotPasswordCart(){
    setTimeout(() => {
    this.forgotPasswordCart = !this.forgotPasswordCart;
  });
}
 ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  
onOTPInput(otp: string) {
  this.enteredOTP = otp;
 
}
loginAuth() {
  debugger;
  this.error = null;

  this.authservice.loginAuthentication(this.loginrequest).subscribe(
    (res: login) => {
      if (res.isSuccess) {
        const user: any = res.loggedUser;
        const token = res.jwT_Token.token;

        sessionStorage.setItem('userData', JSON.stringify(user));
        sessionStorage.setItem('token', token);

        if (this.rememberMe) {
          localStorage.setItem('userData', JSON.stringify(user));
          localStorage.setItem('token', token);
        }

        this.userStateService.setProfileImage(user.profilePhotoUrl);
        this.userStateService.setDisplayName(user.displayName);

        this.router.navigateByUrl('/admin/dashboard');
      } else {
        
        const message = res.errorMessage?.trim();

        if (message === 'Not A Registred Email') {
          this.error = 'Invalid email';
        } else {
          this.error = message || 'Login failed.';
        }
      }
    },
    (error) => {
      console.error('Login failed', error);

      let message = '';

      if (error?.error?.errorMessage) {
        message = error.error.errorMessage.trim();
      } else if (typeof error.error === 'string') {
        message = error.error.trim();
      }

      if (message === 'Not A Registred Email') {
        this.error = 'Invalid email';
      } else if (message === 'Incorrect password') {
        this.error = 'Invalid password';
      } else if (message) {
        this.error = message;
      } else {
        this.error = 'An unexpected error occurred. Please try again.';
      }
    }
  );
}


 nuable()
 {
   this.error = null

 }
enteredOTP: string = '';

 forgotPasswordEmail: string = '';


 onSubmitForgotPassword() {
  this.submittedForgotPasswordEmail = true;
  this.loading=true

  if (!this.forgotPasswordEmail || !this.validateEmail(this.forgotPasswordEmail)) {
    this.loading=false
    return;
  }
this.authservice.sendOtpForForgottedPassword(this.forgotPasswordEmail).subscribe({
  next: (res) => {
    debugger;
    if (res.isSuccess) {
      this.isforgotPasswordStatus = true;
      this.toaster.success(res.message);
    } else {
      this.isforgotPasswordStatus = false;
      this.toaster.error(res.message);
    }
    this.loading = false;
  },
  error: (err) => {
    this.isforgotPasswordStatus = false;
    this.loading = false;

this.toaster.error(err.errorMessage);
  },
  complete: () => {
    console.log('OTP request completed');
  }
});
 
 
  
}

forgotPasswordVerifyOTP() {
  this.authservice.forgotPasswordVerifyOTPservice(this.forgotPasswordEmail, this.enteredOTP).subscribe({
    next: (res) => {
      this.toaster.success("OTP Verified Successfully.");
      setTimeout(() => {
        this.setForgotNewPasswordCart = true;
      });
    },
    error: (error) => {
      if (error.status === 400) {
        this.toaster.error("Enter Correct OTP");
      } else {
        this.toaster.error("An unexpected error occurred.");
      }
    }
  });
}

validateEmail(email: string): boolean {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email.toLowerCase());
}

}



